'use client';

import React, { type JSX } from 'react';

interface ComingSoonPreviewProps {
    title: string;
    description: string;
}

export default function ComingSoonPreview({ title, description }: ComingSoonPreviewProps): JSX.Element {
    return (
        <div className="space-y-6 flex flex-col items-center justify-center min-h-[400px]">
            <div className="text-center space-y-4">
                <h2 className="text-2xl font-semibold text-muted-foreground">Coming Soon</h2>
                <p className="text-lg text-muted-foreground max-w-md">{description}</p>
                <div className="w-16 h-1 bg-primary mx-auto rounded-full"></div>
            </div>

            {/* Preview mockup */}
            <div className="border-2 border-dashed border-muted-foreground/30 rounded-lg p-8 bg-muted/10">
                <div className="text-center text-muted-foreground">
                    <div className="text-sm font-mono mb-2">{title} Preview</div>
                    <div className="text-xs">Widget component coming soon...</div>
                </div>
            </div>
        </div>
    );
}
